module.exports = __webpack_public_path__ + "img/training-fan.e6988d7a.png";